import Unleash from '@js/plugins/unleash';

export default {
    computed: {
        hasReceiptCapillaryOrderLevel() {
            return Unleash.hasFeature('receipt_capillary_order_level');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/receipt-postgres/receipt-feature-flag-mixin.js